import React, { useEffect, useState } from "react";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import Centerheading from "../../components/services/Centerheading";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import Heading from "../../components/Highlightedheading/Heading";
import GridImage from "../../components/GridImage";
import YoutubeEmbed from "../../components/YoutubeEmbedGallery";
import YoutubeEmbedOld from "../../components/YoutubeEmbed";
import contactImg from "../../assets/gallery/career.png";
import mobileImg from "../../assets/gallery/mobile_gallery.png";
import { useWindowSize } from "react-use";
import { btsplaylistThumnail } from "../../assets/gallery";
import axios from "axios";
import config from "../../config/config";
import BannerHeading from "../../components/BannerHeading/Heading";

const Gallery = () => {
  const { width } = useWindowSize();
  const [selectedTab, setSelectedTab] = useState(0);
  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;
  const [isHoveredIndex, setIsHoveredIndex] = useState(null);
  const [instaPosts, setInstaPosts] = useState([]);
  const fetchInstagramPosts = async () => {
    try {
      const response = await axios.get(
        "https://graph.instagram.com/v22.0/me/media",
        {
          params: {
            fields:
              "id,media_type,media_url,username,timestamp,caption,permalink,thumbnail_url",
            access_token: config.instaToken,
            limit: 100,
          },
        }
      );

      if (response.data && response.data.data) {
        let data = response.data.data;
        // let data = response.data.data.filter((media) =>
        //   media.caption?.includes("#InnovateAtISDI")
        // );

        setInstaPosts(data);
        // console.log({ post: data });
      }
    } catch (error) {
      console.error("Instagram API fetch error:", error);
    }
  };
  useEffect(() => {
    fetchInstagramPosts();
  }, []);
  // const galleryImage = [
  //   21, 23, 6, 16, 22, 24, 11, 1, 29, 30, 18, 4, 28, 34, 19, 12, 27, 26, 10, 5,
  //   35, 36, 3, 13, 37, 38, 2, 8, 39, 20, 17, 14, 25, 31, 15, 7, 32, 33, 9,
  // ];

  // const galleryImage = [
  //   1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  //   22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
  // ];

  const imagesLength = Array.from({ length: 100 }, (_, i) => i + 1);

  const imageChunks = [];
  for (let i = 0; i < imagesLength.length; i += 4) {
    imageChunks.push(imagesLength.slice(i, i + 4));
  }

  const btsPlaylist = [
    {
      videoId: "KFzzpzRjgLs",
      name: "UTI",
      thumbnail: btsplaylistThumnail.Uti,
    },
    {
      videoId: "r1NuZi_KdMQ",
      name: "Dabur Vatika",
      thumbnail: btsplaylistThumnail.daburVatika,
    },
    {
      videoId: "VUMyvMThB8k",
      name: "Magic Bricks",
      thumbnail: btsplaylistThumnail.majicBricks,
    },
    {
      videoId: "KYJlWuftUz8",
      name: "ADDA 52",
      thumbnail: btsplaylistThumnail.adda52,
    },
    {
      videoId: "o7pYH5Zzq94",
      name: "Karmma Calling",
      thumbnail: btsplaylistThumnail.karmacalling,
    },
    {
      videoId: "D134u3h8lLA",
      name: "Relaxo Bahamas",
      thumbnail: btsplaylistThumnail.relaxo,
    },
    {
      videoId: "DmJszB6BbS0",
      name: "Maruti Suzuki Vitara Brezza",
      thumbnail: btsplaylistThumnail.brezza,
    },
    {
      videoId: "Bj90SdkV6Ds",
      name: "The Divide",
      thumbnail: btsplaylistThumnail.divide,
    },
    {
      videoId: "FBkYqecteGk",
      name: "Vadilal",
      thumbnail: btsplaylistThumnail.vadilal,
    },
    {
      videoId: "1YhOdy2kV10",
      name: "Set Life",
      thumbnail: btsplaylistThumnail.setlife,
    },
    {
      videoId: "hfgORD1rn7I",
      name: "Salman Khan Exclusive Dubbing",
      thumbnail: btsplaylistThumnail.hanuman,
    },
    {
      videoId: "vp8LQES9dgQ",
      name: "Bitter Sweets",
      thumbnail: btsplaylistThumnail.bittersweet,
    },
    {
      videoId: "aUAb9DwV8KQ",
      name: "Karmma Calling | Bloppers & BTS",
      thumbnail: btsplaylistThumnail.karmmacallingBloppers,
    },
    {
      videoId: "RtfirEmhoEk",
      name: "Hundred BTS",
      thumbnail: btsplaylistThumnail.hundredBts,
    },
    {
      videoId: "XOwKTsQIT8k",
      name: "Vadilal Ice Cream BTS",
      thumbnail: btsplaylistThumnail.vadilalBts,
    },
    {
      videoId: "xh59R6zxmy8",
      name: "Vadilal Misunderstood BTS",
      thumbnail: btsplaylistThumnail.vadilalMisunderstood,
    },
    {
      videoId: "QjSVoRTRj70",
      name: "Vadilal Astronaut BTS",
      thumbnail: btsplaylistThumnail.vadialalAstronaut,
    },
    {
      videoId: "ZXpPo5fS0Zg",
      name: "Vadilal Embarrassed BTS",
      thumbnail: btsplaylistThumnail.vadilalEmbarassed,
    },
    {
      videoId: "sk-WqGiBusw",
      name: "Vadilal Followers BTS",
      thumbnail: btsplaylistThumnail.vadialalFollowers,
    },
    {
      videoId: "tm69eSU1k9U",
      name: "Vadilal Hot Guy BTS",
      thumbnail: btsplaylistThumnail.vadilalHotGuy,
    },
    {
      videoId: "cQ0GNGFxU4c",
      name: "Vadilal Friendzoned BTS",
      thumbnail: btsplaylistThumnail.vadilalFriendZoned,
    },
    {
      videoId: "5Q0L-ZqNL8Q",
      name: "Snickers BTS",
      thumbnail: btsplaylistThumnail.snickersBts,
    },
    {
      videoId: "js6JyxBKEs0",
      name: "The World Of Karmma Calling",
      thumbnail: btsplaylistThumnail.theworldofKarmmacalling,
    },
    {
      videoId: "MatpH3ib-cE",
      name: "Varun Sood as Ahaan Kothari Karmma Calling BTS",
      thumbnail: btsplaylistThumnail.varunSood,
    },
    {
      videoId: "3DHcMIMtQvQ",
      name: "Raveena Tandon as Indrani Kothari | Karmma Calling BTS",
      thumbnail: btsplaylistThumnail.indraniKothari,
    },
  ];

  const handleTabChange = (e) => {
    setSelectedTab(e.target.value);
    // console.log(e.target.value);
  };

  useEffect(() => {
    const preloadImages = [contactImg, mobileImg];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <>
      <div className="relative w-full h-[90vh] md:h-[40vw] 3xl:h-[60vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-10">
          <div className="md:pl-[5.63vw] pl-4 flex items-center md:pt-[10.09vw] pt-[25vw]">
            <Pageheading pageHeading={"Gallery"} icon={<RiHome2Line />} />
          </div>
        </div>
        <div
          className="absolute inset-0 bg-contain md:bg-cover bg-no-repeat bg-left md:bg-center flex justify-center items-center"
          style={{
            backgroundImage: `url(${width < 768 ? mobileImg : contactImg})`,
          }}
        >
          <div className="absolute top-[25vh] md:top-[18vw] md:left-[17.47vw] flex justify-start items-center z-10">
            <BannerHeading headingText={"GALLERY"} />
          </div>
        </div>
        <div className="absolute h-[250px] md:h-[300px] tab:h-[327px] w-full top-0 bg-gradient-to-b from-[#121614]"></div>
      </div>

      <div
        data-aos="fade-up"
        className="relative block tab:hidden px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px]"
      >
        <div className="px-5 py-4 border border-1 border-slate-50/10">
          <select
            onChange={handleTabChange}
            value={selectedTab}
            className="bg-transparent text-white outline-none w-full text-20 leading-7 font-bebas_neue tracking-wider"
          >
            <option value={0} className="px-4 py-2 w-full text-black">
              BTS PLAYLIST
            </option>
            <option value={1} className="px-4 py-2 w-full text-black">
              INSTAGRAM
            </option>
            <option value={2} className="px-4 py-2 w-full text-black">
              GALLERY
            </option>
          </select>
        </div>
      </div>

      {(selectedTab == 0 || width > 992) && (
        <section className="relative w-full px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px]">
          {/* <h2 className="w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          BTS PLAYLIST
        </h2> */}
          <h2
            data-aos="fade-up"
            className="w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
          >
            BTS PLAYLIST
          </h2>
          <div className="grid grid-cols-1 tab:grid-cols-2 xl:grid-cols-4 md:gap-x-[2.08vw] gap-x-[4vw] gap-y-[30px] lg:gap-y-[40px] mt-8">
            {btsPlaylist?.map((video, i) => (
              <div
                data-aos="fade-up"
                className="aspect-[4/3]"
                key={`bts-playlist-${i}`}
              >
                <YoutubeEmbed
                  videoId={video.videoId}
                  thumbnail={video?.thumbnail}
                  iconcss="!size-[48px] sm:!size-[56px] md:!size-[64px] xl:!size-[70px] 3xl-plus:!size-[150px]"
                  iframecss="w-full h-full"
                  isHoveredIndex={isHoveredIndex}
                  setIsHoveredIndex={setIsHoveredIndex}
                />
                <p className="text-15 font-montserrat text-white mt-4 md:mt-6 leading-[25px] 3xl-plus:text-[24px]  3xl-plus:leading-[34px]">
                  {video?.name}
                </p>
              </div>
            ))}
          </div>
        </section>
      )}

      {(selectedTab == 1 || width > 992) && (
        <section className="relative w-full px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px]">
          {/* <h2 className="w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          INSTAGRAM HIGHLIGHTS
        </h2> */}
          <h2
            data-aos="fade-up"
            className="w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
          >
            INSTAGRAM HIGHLIGHTS
          </h2>
          <div className="grid grid-cols-1 tab:grid-cols-2 xl:grid-cols-4 md:gap-x-[2.08vw] gap-x-[4vw] gap-y-[30px] lg:gap-y-[40px] mt-8">
            {instaPosts?.map(
              ({ media_type, media_url, thumbnail_url, permalink }, i) => (
                <a
                  data-aos="fade-up"
                  className="aspect-[4/3] bg-black flex cursor-pointer"
                  key={`insta-post-${i}`}
                  href={permalink}
                  target="_blank"
                >
                  <img
                    src={media_type === "VIDEO" ? thumbnail_url : media_url}
                    alt=""
                    className="aspect-[4/3] object-contain"
                  />
                </a>
              )
            )}
          </div>
        </section>
      )}

      {(selectedTab == 2 || width > 992) && (
        <section className="relative w-full px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px]">
          {/* <h2 className="w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
          DISCOVER OUR HIGHLIGHTED GALLERY
        </h2> */}
          <h2
            data-aos="fade-up"
            className="w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
          >
            DISCOVER OUR HIGHLIGHTED GALLERY
          </h2>

          <div className="mt-8">
            {imageChunks.map((chunk, index) => (
              <GridImage key={index} images={chunk} />
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default Gallery;
